import {UploadDocumentToBucket} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import {toast} from 'react-toastify';
import {requestCompanyDocumentTranslation} from 'redux/store/news/actions';
import {useState} from 'react';
import {Form} from 'antd';

export const useDabaProReportsForm = () => {
  const [form] = Form.useForm();
  const [issueDate, setIssueDate] = useState('');
  const [pdfFile, setPdfFile] = useState('');
  const [loadingPdfUpload, setLoadingPdfUpload] = useState(false);
  const [baseLanguage, setBaseLanguage] = useState('');
  const [documentName, setDocumentName] = useState('');
  const [pdfLink, setPdfLink] = useState('');
  const [viewPdf, setViewPdf] = useState(null);
  const [pdfName, setPdfName] = useState('Supported format: pdf');
  const [translatedData, setTranslatedData] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');

  const handleDeleteFile = () => {
    setPdfFile('');
    setPdfLink('');
    setPdfName('Supported format - pdf');
    setViewPdf('');
  };

  const handlePdfFileSave = e => {
    e.preventDefault();
    setViewPdf(pdfFile);
  };

  const handleChangeTranslation = (key, event) => {
    let eventName = event.target.name;
    let eventValue = event.target.value;
    const newFormValues = [...translatedData];
    newFormValues[key][eventName] = eventValue;
    setTranslatedData(newFormValues);
  };

  const handlePdfFileChange = async e => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && selectedFile.type === 'application/pdf') {
        setLoadingPdfUpload(true);
        const imageUrl = await UploadDocumentToBucket(selectedFile);
        setPdfLink(imageUrl);
        setPdfFile(imageUrl);
        setPdfName(selectedFile.name);
        setLoadingPdfUpload(false);
      } else {
        setPdfFile(null);
        toast.error('Please select a valid pdf file');
      }
    } else {
      toast.error('Select a PDF file');
      setPdfFile('');
      setPdfLink('');
      setPdfName('Supported format - pdf');
      setViewPdf('');
    }
  };

  const handleTranslation = async translateText => {
    const newValues = [...translatedData];

    if (!baseLanguage && !documentName) {
      return toast.error(
        'Please make sure none of the necessary fields needed for translation are empty',
      );
    }

    const translateProps = {
      sourceLang: baseLanguage,
      targetLang: selectedLanguage,
      targetText1: documentName,
    };
    if (newValues.length && newValues[0]) {
      const languageExists = newValues.some(
        data => data?.language === selectedLanguage,
      );
      if (languageExists) {
        const updateTranslation = await requestCompanyDocumentTranslation(
          translateText,
          translateProps,
        );
        const translationIndex = newValues.findIndex(
          data => data.language === selectedLanguage,
        );
        newValues[translationIndex].documentName =
          updateTranslation.documentName;
        newValues[translationIndex].language = updateTranslation.language;
        setTranslatedData(newValues);
      }
    } else {
      const triggerNewTranslation = await requestCompanyDocumentTranslation(
        translateText,
        translateProps,
      );
      if (!triggerNewTranslation) {
        return toast.error('Something went wrong when Translating');
      }
      newValues.push(triggerNewTranslation);
      setTranslatedData(newValues);
    }
  };

  const handleDeleteTranslatedPDFFile = index => {
    const newFormValues = [...translatedData];
    newFormValues[index].pdfLink = null;
    newFormValues[index].pdfFile = null;
    newFormValues[index].viewPdf = null;
    newFormValues[index].pdfName = 'Supported format - pdf';
    setTranslatedData(newFormValues);
  };

  return {
    form,
    issueDate,
    setIssueDate,
    pdfFile,
    setPdfFile,
    loadingPdfUpload,
    setLoadingPdfUpload,
    baseLanguage,
    setBaseLanguage,
    documentName,
    setDocumentName,
    pdfLink,
    setPdfLink,
    viewPdf,
    setViewPdf,
    pdfName,
    setPdfName,
    translatedData,
    setTranslatedData,
    selectedLanguage,
    setSelectedLanguage,
    handleDeleteFile,
    handlePdfFileSave,
    handleChangeTranslation,
    handlePdfFileChange,
    handleTranslation,
    handleDeleteTranslatedPDFFile,
  };
};
